export default "__VITE_ASSET__vvIL5OZZ__"